export default __webpack_public_path__ + "static/media/Biomedical.36517c5c.pdf";